const p1 = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla eu fermentum justo. Sed in commodo est. Duis mattis ultricies quam, quis euismod lorem porta quis. Maecenas faucibus nec sapien a tincidunt. Donec condimentum a nulla a accumsan. Phasellus mi nulla, interdum eu arcu sit amet, laoreet pulvinar felis. Vestibulum suscipit gravida lorem sit amet tempor. Duis ut neque at purus malesuada ultrices. Vestibulum elementum ullamcorper ornare. Quisque laoreet consequat gravida. Nullam sapien tellus, tincidunt quis interdum ac, posuere et magna.'

const p2 = 'Nullam lobortis eu magna nec tristique. Donec metus est, tincidunt et viverra eget, tincidunt nec elit. Suspendisse interdum, purus vel tincidunt efficitur, odio ex ullamcorper velit, quis dapibus arcu leo et neque. Etiam ac odio ex. Morbi arcu eros, ullamcorper a maximus in, vestibulum ut nisl. Mauris nec urna quis dui pharetra fringilla. Pellentesque tempus magna varius mauris tincidunt interdum. Nunc nisi diam, venenatis dignissim tempor eu, ornare vitae sem. Praesent mattis leo felis, sed posuere eros venenatis in. In iaculis, dui quis semper pulvinar, urna magna imperdiet ante, in placerat magna neque eget dui. Donec sagittis ullamcorper metus eget blandit. Curabitur in accumsan ex. Praesent semper nisl ut dictum pharetra. Cras in eros feugiat purus euismod posuere.'

const p3 = 'Vestibulum euismod feugiat risus at feugiat. Aenean maximus neque lectus, sed ultrices nibh sodales iaculis. Nulla nec sollicitudin massa. Pellentesque pulvinar quam dolor, ut elementum ex ullamcorper at. Sed vitae neque ultricies, posuere elit congue, placerat nulla. Aenean eros lorem, placerat ut eros sed, congue efficitur ligula. Praesent molestie fermentum varius.'

const p4 = 'Quisque id dapibus quam, et aliquet mauris. Ut sagittis porta ante tempus vulputate. Sed varius sapien id lorem tincidunt egestas. Mauris leo quam, pharetra et arcu eu, volutpat rutrum tortor. Quisque suscipit felis id libero venenatis, vel porttitor elit suscipit. Donec ullamcorper blandit risus sit amet accumsan. Nullam at convallis augue. Praesent tempus ante dolor, at aliquet ligula bibendum ut.'

const Layout = () => {

  return <div className="hs">

    <div className="bar">

      <h1>title</h1>

    </div>

    <div className="one hs">

      <div className="one vs">

        <div className="one hs">
          {p1}
          {p1}
        </div>

        <div className="one hs">
          {p1}
        </div>

      </div>

      <div className="one hs">
        {p2}
      </div>

      <div className="one hs">
        {p2}
        {p2}
      </div>

    </div>

  </div>
}

export default Layout
